import React, { FC } from 'react'
import { HorizontalLine } from 'components/Utility'
import { OrderTime, OrderType } from 'types/checkout'
import { OrderCardHeader, OrderCardBody, OrderCardFooter, Card } from 'components/Card'
import { sumOrderQuantity, sumShoppingBagQuantity } from 'lib/order'
import { UserType } from 'types/user'
import { sumOrdersPrice } from 'lib/revenue'
import { StoreType } from 'types/store'

type Props = {
  basketNumber: string
  isSearch?: boolean
  manufacturerNames?: string
  orders: OrderType[]
  orderTime: OrderTime
  store?: StoreType
  user?: UserType
  date?: string
}

const OrderCard: FC<Props> = (props) => {
  const { basketNumber, isSearch, manufacturerNames, orders, orderTime, store, user, date } = props
  return (
    <Card>
      <OrderCardHeader
        basketNumber={basketNumber}
        orderTime={orderTime}
        manufacturerNames={manufacturerNames}
        store={store}
        tel={user?.tel || ''}
        username={user?.name || ''}
        userId={user?.user_id || ''}
      />
      <HorizontalLine verticalMargin={16} />
      {orders.map((order) => (
        <React.Fragment key={order.checkout_id}>
          <OrderCardBody isSearch={isSearch} order={order} date={date} />
          <HorizontalLine verticalMargin={16} />
        </React.Fragment>
      ))}
      <OrderCardFooter
        amount={sumOrdersPrice(orders, true)}
        quantity={sumOrderQuantity(orders)}
        shoppingBagQuantity={sumShoppingBagQuantity(orders)}
      />
    </Card>
  )
}

export default OrderCard
